import { Controller } from "@hotwired/stimulus"

// Manages import wizard step transitions and file upload validation
export default class extends Controller {
  static targets = [
    "fileInput",
    "fileName",
    "submitButton",
    "submitLabel",
    "submitSpinner",
    "stepIndicator",
  ]

  static values = {
    invalidFileMessage: {
      type: String,
      default: "Please select an .xlsx or .csv file",
    },
    validatingLabel: { type: String, default: "" },
  }

  connect() {
    this.restoreSubmit = this.restoreSubmit.bind(this)
    window.addEventListener("pageshow", this.restoreSubmit)
    this.updateSubmitState()
  }

  disconnect() {
    window.removeEventListener("pageshow", this.restoreSubmit)
  }

  // CONEK-6269: validation runs inside the upload request and takes tens of
  // seconds on a large workbook. Show a busy state so the page does not look
  // frozen; disabling here (loading state) also blocks a duplicate upload.
  // The event is never cancelled — the form posts as before.
  submit() {
    if (!this.hasSubmitButtonTarget) return

    const button = this.submitButtonTarget
    button.disabled = true
    button.setAttribute("aria-busy", "true")
    button.dataset.loading = "true"
    if (this.hasSubmitSpinnerTarget) {
      this.submitSpinnerTarget.classList.remove("hidden")
    }
    if (this.hasSubmitLabelTarget && this.validatingLabelValue) {
      this.idleLabel = this.submitLabelTarget.textContent
      this.submitLabelTarget.textContent = this.validatingLabelValue
    }
  }

  // The form posts with Turbo off, so Back can restore this page from the
  // back-forward cache with the busy state frozen in place.
  restoreSubmit(event) {
    if (!event.persisted || !this.hasSubmitButtonTarget) return

    const button = this.submitButtonTarget
    button.removeAttribute("aria-busy")
    delete button.dataset.loading
    if (this.hasSubmitSpinnerTarget) {
      this.submitSpinnerTarget.classList.add("hidden")
    }
    if (this.hasSubmitLabelTarget && this.idleLabel !== undefined) {
      this.submitLabelTarget.textContent = this.idleLabel
    }
    this.updateSubmitState()
  }

  selectFile(event) {
    const input = event.target
    if (input.files && input.files.length > 0) {
      const file = input.files[0]
      const validExtensions = [".xlsx", ".csv"]
      const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase()

      if (!validExtensions.includes(ext)) {
        alert(this.invalidFileMessageValue)
        input.value = ""
        this.updateSubmitState()
        return
      }

      if (this.hasFileNameTarget) {
        this.fileNameTarget.textContent = file.name
      }
    }
    this.updateSubmitState()
  }

  updateSubmitState() {
    if (!this.hasSubmitButtonTarget || !this.hasFileInputTarget) return

    const hasFile =
      this.fileInputTarget.files && this.fileInputTarget.files.length > 0
    this.submitButtonTarget.disabled = !hasFile
    if (hasFile) {
      this.submitButtonTarget.classList.remove(
        "opacity-50",
        "cursor-not-allowed",
      )
    } else {
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
    }
  }
}
